export var TradeErrorHighlightLocationEnum = /*#__PURE__*/ function(TradeErrorHighlightLocationEnum) {
    TradeErrorHighlightLocationEnum[TradeErrorHighlightLocationEnum["ProposalWanted"] = 0] = "ProposalWanted";
    TradeErrorHighlightLocationEnum[TradeErrorHighlightLocationEnum["ProposalOffered"] = 1] = "ProposalOffered";
    TradeErrorHighlightLocationEnum[TradeErrorHighlightLocationEnum["WantedSelector"] = 2] = "WantedSelector";
    TradeErrorHighlightLocationEnum[TradeErrorHighlightLocationEnum["OfferedSelector"] = 3] = "OfferedSelector";
    return TradeErrorHighlightLocationEnum;
}({});
export var TradeActions = /*#__PURE__*/ function(TradeActions) {
    TradeActions[TradeActions["Accept"] = 0] = "Accept";
    TradeActions[TradeActions["Reject"] = 1] = "Reject";
    TradeActions[TradeActions["CounterOfferCreating"] = 2] = "CounterOfferCreating";
    TradeActions[TradeActions["CounterOfferCreatedOrCanceled"] = 3] = "CounterOfferCreatedOrCanceled";
    return TradeActions;
}({});
export var TradeOfferOpponentDisplay = /*#__PURE__*/ function(TradeOfferOpponentDisplay) {
    TradeOfferOpponentDisplay[TradeOfferOpponentDisplay["AvatarContainer"] = 0] = "AvatarContainer";
    TradeOfferOpponentDisplay[TradeOfferOpponentDisplay["ResponseButtons"] = 1] = "ResponseButtons";
    return TradeOfferOpponentDisplay;
}({});
